/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 (function () {
    const languageSwitcher = document.querySelectorAll(".lang-changer");
    languageSwitcher?.forEach((switcher) => {
        switcher.addEventListener("click", function (event) {
            window.location.href = event.currentTarget.getAttribute("data-value");
        });
    });
    const countryChangers = document.querySelectorAll(".country-button");
    countryChangers.forEach((countryChanger) => {
        countryChanger.addEventListener("click", function (event) {
            let link = event.currentTarget.getAttribute("data-link");
    		console.log(link);
            window.location.href = link; //open in same tab
        });
    });
})();


setInterval(function() {

    if(document.querySelector(".tee-price--saving").querySelectorAll(".money.theme-money.price")) {
        var compare_price = document.querySelector(".money.theme-money.price.tee-price--compare").innerHTML;
        var regular_price = document.querySelector(".money.tee-price--current").innerHTML;

        compare_price = compare_price.replace("€", "");
        regular_price = regular_price.replace("€", "");

        var precent = ((parseFloat(compare_price) - parseFloat(regular_price)) / parseFloat(compare_price)) * 100;

        document.querySelector(".tee-price--saving").querySelectorAll(".money.theme-money.price")[0].innerHTML = parseInt(precent) + "%";
    }
}, 200);